const co2 = [
315.7,
317.45,
317.51,
317.24,
315.86,
314.93,
313.2,
312.43,
313.33,
314.67,
315.58,
316.48,
316.65,
317.72,
318.29,
318.15,
316.54,
314.8,
313.84,
313.33,
314.81,
315.58,
316.43,
316.98,
317.58,
319.03,
320.04,
319.59,
318.18,
315.9,
314.17,
313.83,
315.0,
316.19,
316.89,
317.7,
318.54,
319.48,
320.58,
319.77,
318.57,
316.79,
314.99,
315.31,
316.1,
317.01,
317.94,
318.55,
319.68,
320.57,
321.02,
320.62,
319.61,
317.4,
316.25,
315.42,
316.69,
317.7,
318.74,
319.07,
319.86,
321.38,
322.25,
321.48,
319.74,
317.77,
316.21,
315.99,
317.07,
318.35,
319.57,
320.01,
320.74,
321.84,
322.26,
321.89,
320.44,
318.69,
316.7,
316.87,
317.68,
318.71,
319.44,
320.44,
320.89,
322.14,
322.17,
321.87,
321.21,
318.87,
317.81,
317.3,
318.87,
319.42,
320.62,
321.6,
322.39,
323.7,
324.08,
323.75,
322.38,
320.36,
318.64,
318.1,
319.78,
321.03,
322.33,
322.5,
323.04,
324.42,
325.0,
324.09,
322.54,
320.92,
319.25,
319.39,
320.73,
321.96,
322.57,
323.15,
323.89,
325.02,
325.57,
325.36,
324.14,
322.11,
320.33,
320.25,
321.32,
322.89,
324.0,
324.42,
325.63,
326.66,
327.38,
326.71,
325.88,
323.66,
322.38,
321.78,
322.86,
324.12,
325.06,
325.98,
326.93,
328.13,
328.08,
327.67,
326.34,
324.69,
323.1,
323.06,
324.01,
325.13,
326.17,
326.68,
327.17,
327.79,
328.93,
328.57,
327.36,
325.43,
323.36,
323.56,
324.8,
326.01,
326.77,
327.63,
327.75,
329.72,
330.07,
329.09,
328.04,
326.32,
324.84,
325.2,
326.5,
327.55,
328.55,
329.56,
330.3,
331.5,
332.48,
332.07,
330.87,
329.31,
327.51,
327.18,
328.16,
328.64,
329.35,
330.71,
331.48,
332.65,
333.19,
332.2,
331.07,
329.15,
327.33,
327.28,
328.31,
329.58,
330.73,
331.46,
331.94,
333.11,
333.95,
333.42,
331.97,
329.95,
328.5,
328.36,
329.38,
330.78,
331.56,
332.74,
333.36,
334.74,
334.72,
333.98,
333.08,
330.68,
328.96,
328.72,
330.16,
331.62,
332.68,
333.17,
334.96,
336.14,
336.93,
336.17,
334.89,
332.56,
331.29,
331.28,
332.46,
333.6,
334.94,
335.26,
336.66,
337.69,
338.02,
338.01,
336.5,
334.42,
332.36,
332.45,
333.76,
334.91,
336.14,
336.69,
338.27,
338.82,
339.24,
339.26,
337.54,
335.72,
333.97,
334.24,
335.32,
336.82,
337.9,
338.34,
340.07,
340.93,
341.45,
341.36,
339.45,
337.67,
336.25,
336.14,
337.3,
338.29,
339.29,
340.55,
341.63,
342.6,
343.04,
342.54,
340.82,
338.48,
336.95,
337.05,
338.57,
339.91,
340.93,
341.76,
342.77,
343.96,
344.77,
343.88,
342.42,
340.24,
338.38,
338.41,
339.44,
340.78,
341.57,
342.79,
343.37,
345.4,
346.14,
345.76,
344.32,
342.51,
340.46,
340.53,
341.79,
343.2,
344.21,
344.92,
345.68,
347.37,
347.78,
347.16,
345.79,
343.74,
341.59,
341.86,
343.31,
345.0,
345.48,
346.41,
347.91,
348.66,
349.28,
348.65,
346.9,
345.26,
343.47,
343.35,
344.73,
346.12,
346.78,
347.48,
348.25,
349.86,
350.52,
349.98,
348.25,
346.17,
345.48,
344.82,
346.22,
347.49,
348.73,
348.92,
349.81,
351.4,
352.15,
351.58,
350.21,
348.2,
346.66,
346.72,
348.08,
349.28,
350.51,
351.7,
352.5,
353.67,
354.35,
353.88,
352.8,
350.49,
348.97,
349.37,
350.42,
351.62,
353.07,
353.43,
354.08,
355.72,
355.95,
355.44,
354.05,
351.84,
350.09,
350.33,
351.55,
352.91,
353.86,
355.1,
355.75,
356.38,
357.38,
356.39,
354.89,
353.06,
351.38,
351.69,
353.14,
354.41,
354.93,
355.82,
357.33,
358.77,
359.23,
358.23,
356.3,
353.97,
352.34,
352.43,
353.89,
355.21,
356.34,
357.21,
357.97,
359.22,
359.71,
359.44,
357.15,
354.99,
353.01,
353.41,
354.42,
355.68,
357.1,
357.42,
358.59,
359.39,
360.3,
359.64,
357.45,
355.76,
354.14,
354.23,
355.53,
357.03,
358.36,
359.04,
360.11,
361.36,
361.78,
360.94,
359.51,
357.59,
355.86,
356.21,
357.65,
359.1,
360.04,
361.0,
361.98,
363.44,
363.83,
363.33,
361.78,
359.33,
358.32,
358.14,
359.61,
360.82,
362.2,
363.36,
364.28,
364.69,
365.25,
365.06,
363.69,
361.55,
359.69,
359.72,
361.04,
362.39,
363.24,
364.21,
364.65,
366.49,
366.77,
365.73,
364.46,
362.4,
360.44,
360.98,
362.65,
364.51,
365.39,
366.1,
367.36,
368.79,
369.56,
369.13,
367.98,
366.1,
364.16,
364.54,
365.67,
367.3,
368.35,
369.28,
369.84,
371.15,
371.12,
370.46,
369.61,
367.06,
364.95,
365.52,
366.88,
368.26,
369.45,
369.71,
370.75,
371.98,
371.75,
371.87,
370.02,
368.27,
367.15,
367.18,
368.53,
369.83,
370.76,
371.69,
372.63,
373.55,
374.03,
373.4,
371.68,
369.78,
368.34,
368.61,
369.94,
371.42,
372.7,
373.37,
374.3,
375.19,
375.93,
375.69,
374.16,
372.03,
370.92,
370.73,
372.43,
373.98,
375.07,
375.82,
376.64,
377.92,
378.78,
378.46,
376.88,
374.57,
373.34,
373.31,
374.84,
376.17,
377.17,
378.05,
379.06,
380.54,
380.8,
379.87,
377.65,
376.17,
374.43,
374.63,
376.33,
377.68,
378.63,
379.91,
380.95,
382.48,
382.64,
382.4,
380.93,
378.93,
376.89,
377.19,
378.54,
380.31,
381.58,
382.4,
382.86,
384.8,
385.22,
384.24,
382.65,
380.6,
379.04,
379.33,
380.35,
382.02,
383.1,
384.12,
384.81,
386.73,
386.78,
386.33,
384.73,
382.24,
381.2,
381.37,
382.7,
384.19,
385.78,
386.06,
386.28,
387.33,
388.78,
387.99,
386.61,
384.32,
383.41,
383.21,
384.41,
385.79,
387.17,
387.7,
389.04,
389.76,
390.36,
389.7,
388.24,
386.29,
384.95,
384.64,
386.23,
387.63,
388.91,
390.41,
391.37,
392.67,
393.21,
392.38,
390.41,
388.54,
387.03,
387.43,
388.87,
389.99,
391.5,
392.05,
392.8,
393.44,
394.41,
393.95,
392.72,
390.33,
389.28,
389.19,
390.48,
392.06,
393.31,
394.04,
394.59,
396.38,
396.93,
395.91,
394.56,
392.59,
391.32,
391.27,
393.2,
394.57,
395.78,
397.03,
397.66,
398.64,
400.02,
398.81,
397.51,
395.39,
393.72,
393.9,
395.36,
397.03,
398.04,
398.27,
399.91,
401.51,
401.96,
401.43,
399.27,
397.18,
395.54,
396.16,
397.4,
399.08,
400.18,
400.55,
401.74,
403.35,
404.15,
402.97,
401.46,
399.11,
397.82,
398.49,
400.27,
402.06,
402.73,
404.25,
405.06,
407.6,
407.9,
406.99,
404.59,
402.45,
401.23,
401.79,
403.72,
404.64,
406.36,
406.66,
407.54,
409.22,
409.89,
409.08,
407.33,
405.32,
403.57,
403.82,
405.31,
407.0,
408.15,
408.52,
409.59,
410.45,
411.44,
410.99,
408.9,
407.16,
405.71,
406.19,
408.21,
409.27,
411.03,
411.96,
412.18,
413.54,
414.86,
414.16,
411.97,
410.18,
408.76,
408.75,
410.48,
411.98,
413.61,
414.34,
414.74,
416.45,
417.31,
416.6,
414.62,
412.78,
411.52,
411.51,
413.12,
414.26,
415.52,
416.75,
417.64,
419.05,
419.13,
418.94,
416.96,
414.47,
413.3,
413.93,
415.01,
416.71,
418.19,
419.28,
418.81,
420.23,
420.99,
420.99,
418.9,
417.19,    
]

export default co2